import { Building2, TrendingUp, DoorOpen, Wrench, Gauge, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

const Card = ({ icon: Icon, label, value, sub, tone, testid, filter, active, onClick, onPress }) => {
  const clickable = !!filter || !!onPress;
  const handle = onPress ? onPress : (filter ? () => onClick(filter) : undefined);
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={clickable ? handle : undefined}
      disabled={!clickable}
      className={cn(
        "bg-white border rounded-lg p-2.5 sm:p-4 flex items-start gap-2.5 sm:gap-3 shadow-sm text-left transition-all min-w-0",
        clickable && "hover:shadow-md hover:border-slate-300 cursor-pointer hover:-translate-y-0.5",
        active ? "border-slate-900 ring-1 ring-slate-900" : "border-slate-200",
        !clickable && "cursor-default"
      )}
    >
      <div className={`h-8 w-8 sm:h-10 sm:w-10 shrink-0 rounded-md flex items-center justify-center ${tone}`}>
        <Icon className="h-4 w-4 sm:h-5 sm:w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[10px] sm:text-xs font-bold sm:font-semibold font-mono-nums uppercase tracking-tight sm:tracking-wider text-slate-500 truncate">
          {label}
        </p>
        <p className="font-display text-xl sm:text-2xl font-bold text-slate-900 leading-tight mt-0.5 sm:mt-0">
          {value}
        </p>
        {sub && (
          <p className="text-[11px] sm:text-xs text-slate-500 mt-0.5 truncate">
            {sub}
          </p>
        )}
      </div>
    </button>
  );
};

export const KpiStrip = ({ stats, activeFilter, onFilter, onMeterLogs }) => {
  if (!stats) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-2 sm:gap-3" data-testid="kpi-strip">
      <Card icon={Building2} label="Total Units" value={stats.total} tone="bg-slate-100 text-slate-700" testid="kpi-total" filter="all" active={activeFilter === "all"} onClick={onFilter} />
      <Card icon={TrendingUp} label="Occupancy" value={`${stats.occupancy_rate}%`} sub={`${stats.occupied} occupied`} tone="bg-blue-100 text-blue-700" testid="kpi-occupancy" filter="occupied" active={activeFilter === "occupied"} onClick={onFilter} />
      <Card icon={DoorOpen} label="Vacant" value={stats.vacant} sub="available" tone="bg-green-100 text-green-700" testid="kpi-vacant" filter="vacant" active={activeFilter === "vacant"} onClick={onFilter} />
      <Card icon={Wrench} label="Maintenance" value={stats.maintenance} sub="flagged" tone="bg-orange-100 text-orange-700" testid="kpi-maintenance" filter="maintenance" active={activeFilter === "maintenance"} onClick={onFilter} />
      <Card icon={Sparkles} label="Needs Cleaning" value={stats.needs_cleaning ?? 0} sub="to clean" tone="bg-cyan-100 text-cyan-700" testid="kpi-needs-cleaning" filter="needs_cleaning" active={activeFilter === "needs_cleaning"} onClick={onFilter} />
      <Card icon={Gauge} label="Meter Logs" value={stats.readings_logged} sub="view readings" tone="bg-slate-100 text-slate-700" testid="kpi-readings" onPress={onMeterLogs} />
    </div>
  );
};